module.exports = __webpack_public_path__ + "static/media/eye.49459954.png";